import { type AdminMessage } from "@sendbird/chat/message";

import { parseFacilityChatMessage } from "../../appV2/Chat/utils";

interface WorkerLockNotificationMessageProps {
  message: AdminMessage;
}

/**
 * Renders a worker lock notification as an outgoing message bubble with preserved newlines.
 * Uses Sendbird CSS variables for consistent styling with the rest of the legacy chat.
 */
export function WorkerLockNotificationMessage(props: WorkerLockNotificationMessageProps) {
  const { message } = props;
  const displayMessage = parseFacilityChatMessage(message) ?? message.message;

  return (
    <div style={{ display: "flex", justifyContent: "flex-end", margin: "8px 12px" }}>
      <div
        style={{
          maxWidth: "80%",
          padding: "8px 12px",
          borderRadius: "24px 24px 4px 24px",
          backgroundColor: "var(--sendbird-light-primary-300, #032e68)",
          color: "var(--sendbird-light-ondark-01, white)",
          fontSize: "16px",
          fontFamily: "var(--sendbird-font-family-default, inherit)",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          lineHeight: 1.5,
        }}
      >
        {displayMessage}
      </div>
    </div>
  );
}
